module.exports = __webpack_public_path__ + "img/logo.69f4ebb4.png";